import { Flex, type FlexProps } from "@chakra-ui/react";
import type { FC, PropsWithChildren } from "react";

interface FlexContainerProps extends PropsWithChildren {
    flexProps?: FlexProps;
}

const FlexContainer: FC<FlexContainerProps> = ({ children, flexProps }) => {
    return (
        <Flex flexDir={"column"} h={"100vh"} bgColor="gray.050" {...flexProps}>
            {children}
        </Flex>
    );
};

export default FlexContainer;
